/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { getCurrentRegionOIDCConfigs } from "../APIsUtils/httpsUtils";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export default class MsalConfig {
    static instance;

    getMsalConfig() {
        const currentRegionOIDCConfigs = getCurrentRegionOIDCConfigs();
        const { entra } = currentRegionOIDCConfigs
        return {
            auth: {
                clientId: entra.clientId,
                authority: entra.authority,
                redirectUri: window.location.origin, // this needs to be configured in Entra settings by Entra Team
                navigateToLoginRequestUrl: false,
            },
            cache: {
                cacheLocation: "localStorage", // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                loggerOptions: {
                    loggerCallback: (level, message, containsPii) => {
                        if (containsPii) {
                            return;
                        }
                        switch (level) {
                            case LogLevel.Error:
                                console.error(message);
                                return;
                            case LogLevel.Info:
                                console.info(message);
                                return;
                            case LogLevel.Verbose:
                                console.debug(message);
                                return;
                            case LogLevel.Warning:
                                console.warn(message);
                                return;
                            default:
                                return;
                        }
                    }
                }
            }
        }
    }

    getMsalInstance() {
        if (!MsalConfig.instance) {
            MsalConfig.instance = new PublicClientApplication(this.getMsalConfig());
        }
        return MsalConfig.instance;
    }

    logout = () => {
        const msalInstance = this.getMsalInstance();
        const account = msalInstance.getActiveAccount();
    
        msalInstance.logoutRedirect({
            account: account,
            postLogoutRedirectUri: window.location.origin
        });
    };
}


/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};
